/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Welcome_Banner_CtaInputs */

const en_company_welcome_banner_cta = /** @type {(inputs: Company_Welcome_Banner_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Profile`)
};

const de_company_welcome_banner_cta = /** @type {(inputs: Company_Welcome_Banner_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensprofil`)
};

/**
* | output |
* | --- |
* | "Company Profile" |
*
* @param {Company_Welcome_Banner_CtaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_welcome_banner_cta = /** @type {((inputs?: Company_Welcome_Banner_CtaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Welcome_Banner_CtaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_welcome_banner_cta(inputs)
	return en_company_welcome_banner_cta(inputs)
});